module.exports = __webpack_public_path__ + "img/WLGravity-white.302bb555.svg";